import { render, staticRenderFns } from "./studentInformationQueryAQSC.vue?vue&type=template&id=3ffe5b8f&scoped=true"
import script from "./studentInformationQueryAQSC.vue?vue&type=script&lang=js"
export * from "./studentInformationQueryAQSC.vue?vue&type=script&lang=js"
import style0 from "./studentInformationQueryAQSC.vue?vue&type=style&index=0&id=3ffe5b8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffe5b8f",
  null
  
)

export default component.exports